import { API_BASE_URL } from '../config';

export const THEME_NAMES = ['Default', 'Nature Green', 'Sea Blue', 'Homoeopathic', 'Ayurvedic', 'Panchakarma'];

export const THEMES = {
  Default: {
    label: 'Default',
    description: 'The current clinic look',
    primary: '#1f4d40',
    primaryDark: '#16382f',
    accent: '#e7c98a',
    wash: '#f8f9fa',
    loginFrom: '#16382f',
    loginMid: '#1f4d40',
    loginDeep: '#0f2923',
    keepRoleColors: true
  },
  'Nature Green': {
    label: 'Nature Green',
    description: 'Leaf green screens',
    primary: '#2e7d32',
    primaryDark: '#1b5e20',
    accent: '#c5e1a5',
    wash: '#f1f8f2',
    loginFrom: '#1b5e20',
    loginMid: '#2e7d32',
    loginDeep: '#0d3312',
    keepRoleColors: false
  },
  'Sea Blue': {
    label: 'Sea Blue',
    description: 'Calm blue screens',
    primary: '#1565c0',
    primaryDark: '#0d47a1',
    accent: '#81d4fa',
    wash: '#f3f8fc',
    loginFrom: '#0d47a1',
    loginMid: '#1565c0',
    loginDeep: '#082c66',
    keepRoleColors: false
  },
  Homoeopathic: {
    label: 'Homoeopathic',
    description: 'Soft violet screens',
    primary: '#6a1b9a',
    primaryDark: '#4a148c',
    accent: '#e1bee7',
    wash: '#f8f4fb',
    loginFrom: '#4a148c',
    loginMid: '#6a1b9a',
    loginDeep: '#2a0a52',
    keepRoleColors: false
  },
  Ayurvedic: {
    label: 'Ayurvedic',
    description: 'Earth and turmeric screens',
    primary: '#8d4b1f',
    primaryDark: '#5c3310',
    accent: '#e6b325',
    wash: '#fbf6ee',
    loginFrom: '#5c3310',
    loginMid: '#8d4b1f',
    loginDeep: '#3a220c',
    keepRoleColors: false
  },
  Panchakarma: {
    label: 'Panchakarma',
    description: 'Maroon and saffron screens',
    primary: '#7b2d26',
    primaryDark: '#4a1c18',
    accent: '#e07a3d',
    wash: '#fbf3ef',
    loginFrom: '#4a1c18',
    loginMid: '#7b2d26',
    loginDeep: '#2c100e',
    keepRoleColors: false
  }
};

export const COLOR_PALETTE = [
  '#1f4d40',
  '#2e7d32',
  '#1565c0',
  '#6a1b9a',
  '#8d4b1f',
  '#7b2d26',
  '#c47b12',
  '#0f766e',
  '#9a3412',
  '#1e3a5f'
];

export const DEFAULT_APPEARANCE = { theme: 'Default', prescriptionColor: '#1f4d40' };

export function themeByName(name) {
  return THEMES[name] || THEMES.Default;
}

export function applyClinicTheme(appearance) {
  const theme = themeByName(appearance && appearance.theme);
  const root = document.documentElement;
  root.dataset.clinicTheme = theme.keepRoleColors ? 'default' : 'custom';
  root.style.setProperty('--theme-primary', theme.primary);
  root.style.setProperty('--theme-primary-dark', theme.primaryDark);
  root.style.setProperty('--theme-accent', theme.accent);
  root.style.setProperty('--theme-wash', theme.wash);
  root.style.setProperty('--login-from', theme.loginFrom);
  root.style.setProperty('--login-mid', theme.loginMid);
  root.style.setProperty('--login-deep', theme.loginDeep);
  root.style.setProperty('--login-kicker', theme.accent);
  root.style.setProperty('--login-screen', theme.keepRoleColors ? '#f3f6f4' : theme.wash);
}

export async function loadAppearance() {
  try {
    const response = await fetch(`${API_BASE_URL}/clinic/appearance`);
    if (!response.ok) return DEFAULT_APPEARANCE;
    const data = await response.json();
    const theme = THEMES[data.theme] ? data.theme : 'Default';
    const color = /^#[0-9a-fA-F]{6}$/.test(data.prescriptionColor || '')
      ? data.prescriptionColor.toLowerCase()
      : DEFAULT_APPEARANCE.prescriptionColor;
    return { theme, prescriptionColor: color };
  } catch (error) {
    return DEFAULT_APPEARANCE;
  }
}
